import angular from 'angular';
import '../core.module';

export const VERSION_CHECK_INTERVAL_MS = 60_000;
const RUNTIME_SCRIPT_PATTERN = /\/js\/runtime\.[\w-]+\.js/;

export function loadedRuntimePath(document) {
  if (!document || !document.querySelector) return null;
  const script = document.querySelector('script[src*="/js/runtime."]');
  const match = script && RUNTIME_SCRIPT_PATTERN.exec(script.getAttribute('src'));
  return match ? match[0] : null;
}

function registerAppVersionGuard($transitions, $window, $document, $state, $q) {
  const currentRuntime = loadedRuntimePath($document[0]);
  if (!currentRuntime || !$window.fetch) return;

  let lastCheckAt = Date.now();
  let outdated = false;

  function checkVersion() {
    lastCheckAt = Date.now();
    return $q
      .when($window.fetch('/index.html', { cache: 'no-store' }))
      .then((response) => (response.ok ? response.text() : ''))
      .then((html) => {
        const match = RUNTIME_SCRIPT_PATTERN.exec(html);
        if (match && match[0] !== currentRuntime) outdated = true;
      })
      .catch(() => null);
  }

  $transitions.onStart({}, (transition) => {
    const due = Date.now() - lastCheckAt >= VERSION_CHECK_INTERVAL_MS;
    return (due ? checkVersion() : $q.when()).then(() => {
      if (!outdated) return true;
      $window.location.assign($state.href(transition.to(), transition.params()));
      return false;
    });
  });
}

registerAppVersionGuard.$inject = ['$transitions', '$window', '$document', '$state', '$q'];

angular.module('app.core').run(registerAppVersionGuard);
